// extracted by mini-css-extract-plugin
export default {"title":"text_title__YaVQz","subtitle":"text_subtitle__yeJhs"};